module.exports = __webpack_public_path__ + "static/media/suggestion.4a478312.svg";